import { createSlice, PayloadAction, PrepareAction } from '@reduxjs/toolkit'
// @ts-expect-error uuid v3 uses subpath imports
import uuidv4 from 'uuid/v4'

type NotificationType = 'success' | 'error' | 'warning' | 'info'

interface Notification {
  message: unknown
  category: string
  id: string
  notificationType: NotificationType
}

interface NotificationState {
  notification: Notification | null
}

const initialState: NotificationState = {
  notification: null,
}

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    broadcastMessage: {
      prepare(
        message: unknown,
        category: string,
        notificationType: NotificationType = 'success'
      ) {
        return { payload: { message, category, notificationType, id: uuidv4() } }
      },
      reducer(state, action: PayloadAction<Notification>) {
        state.notification = action.payload
      },
    },
    reset: () => initialState,
  },
})

export const notificationActions = notificationSlice.actions
export const notificationReducer = notificationSlice.reducer
export default notificationActions
